'use client'

import { useStoreLocatorUrl } from '@/feature/store-locator'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import {
  Illustration,
  illustrationNames,
  type IllustrationName,
} from '@/ui/illustrations/illustration/Illustration'
import { Link } from '@/ui/links/link/Link.client'

const DEFAULT_FOOTER_MAP_ILLUSTRATION: IllustrationName = 'france'
const CLASSNAME = 'relative w-[8.75rem] desktop:w-full'

const isIllustrationName = (value: string): value is IllustrationName =>
  (illustrationNames as readonly string[]).includes(value)

export function FooterMap() {
  const storeLocatorUrl = useStoreLocatorUrl()
  const { t } = useTranslation(['generic'])
  const ariaLabel = t('generic:footerMapAlt')
  const translationIllustration = t('generic:footerMapIllustration')
  const footerMapIllustration = isIllustrationName(translationIllustration)
    ? translationIllustration
    : DEFAULT_FOOTER_MAP_ILLUSTRATION

  if (!storeLocatorUrl) {
    return (
      <div className={CLASSNAME} aria-label={ariaLabel} role="img">
        <Illustration name={footerMapIllustration} />
      </div>
    )
  }

  return (
    <Link
      variant="free"
      href={storeLocatorUrl}
      target="_blank"
      className={CLASSNAME}
      aria-label={ariaLabel}
      trackingData={{
        event: 'gaEvent',
        eventCategory: 'footer',
        eventAction: 'clic',
        eventLabel: 'carte',
      }}
    >
      <Illustration name={footerMapIllustration} />
    </Link>
  )
}
